import client from '@/api/client'
import CAMPAIGN_QUERY from '@/api/gql/_shared/dynamic-yield/query/campaigns.gql'
import { toData } from '@/helpers/request'
import { onDOMContentLoaded } from '@/helpers/event'
import { toRetry } from '@/helpers/request'
import REPORT_DY_ENGAGEMENT_MUTATION from '@/api/gql/_shared/dynamic-yield/mutation/report-dy-engagement.gql'
import REPORT_DY_EVENT_MUTATION from '@/api/gql/_shared/dynamic-yield/mutation/report-dy-events.gql'
import REPORT_DY_PAGEVIEW_MUTATION from '@/api/gql/_shared/dynamic-yield/mutation/report-dy-pageview.gql'
import DYNAMIC_OVERLAY_QUERY from '@/api/gql/_shared/dynamic-yield/query/dynamic-overlay.gql'

const DELAY_UNTIL_NEXT_REPORT = 1000
const hasReportedToDyRecently = {}
let referer = null

const DynamicYieldService = {
  async reportEngagement(campaignIds) {
    if (!campaignIds) {
      // eslint-disable-next-line no-console
      console.warn('[DynamicYieldService] - Unable to report engagement without campaign ids')
      return
    }
    const { variationId, decisionId } = campaignIds
    const id = `${variationId}__${decisionId}`
    if (!variationId || !decisionId || hasReportedToDyRecently[id]) return

    await toRetry(
      () =>
        client.mutate({
          mutation: REPORT_DY_ENGAGEMENT_MUTATION,
          variables: { variations: [variationId], decisionId },
        }),
      {
        retryCount: 1,
        isSuccessfulInResponse: ({ data }) => data?.reportDyEngagement?.success,
      }
    )
    hasReportedToDyRecently[id] = true
    setTimeout(() => (hasReportedToDyRecently[id] = false), DELAY_UNTIL_NEXT_REPORT)
  },

  async reportEvents(events) {
    await onDOMContentLoaded()
    await toRetry(
      () => client.mutate({ mutation: REPORT_DY_EVENT_MUTATION, variables: { events } }),
      {
        retryCount: 1,
        isSuccessfulInResponse: ({ data }) => data?.reportDyEvents?.success,
      }
    )
  },

  async fetchCampaign(selectors, targeting) {
    const variables = { selectors, targeting }
    const result = await toData(client.query({ query: CAMPAIGN_QUERY, variables }))
    return result?.data
  },

  async reportPageview(pageType, pageData) {
    const url = window.location.href
    const variables = { pageType, pageData, url, referer }
    const action = () => client.mutate({ mutation: REPORT_DY_PAGEVIEW_MUTATION, variables })
    referer = url

    await toRetry(action) // Will not retry if the request to the DY API has timed out
  },

  async fetchDynamicOverlay() {
    const result = await toData(client.query({ query: DYNAMIC_OVERLAY_QUERY }))
    return result?.data
  },
}
window.On = window.On || {}
window.On.DynamicYieldService = DynamicYieldService

export default DynamicYieldService
